/**
 * Local read hints for Message Requests (#5059). State only: pm/requests.js owns the DOM side and is the only caller.
 */
(function () {
  'use strict';

  // By thread id. loadedAt is the seq at which a load that applied the read
  // came back, null before that. after is the newest thread-view load id at the
  // open: a load at or below it started before the open and does not count.
  var hints = Object.create(null);
  var seq = 0;

  /** A banner's data-unread-threads as id to unread count, read rows at 0. */
  function servedThreads(sec) {
    var served = Object.create(null);
    if (!sec) return served;
    (sec.getAttribute('data-unread-threads') || '').trim().split(/\s+/).forEach(function (part) {
      var kv = part.split(':');
      if (kv.length === 2 && kv[0]) served[kv[0]] = parseInt(kv[1], 10) || 0;
    });
    return served;
  }

  /**
   * An unread request is about to load. Only a request the banner counts gets a
   * hint. A confirmed hint keeps its state. An unconfirmed one moves to the new load.
   */
  function note(id, served, afterLoadId) {
    var key = String(id);
    var hint = hints[key];
    var after = afterLoadId === undefined ? null : afterLoadId;
    if (hint) {
      if (hint.loadedAt === null) hint.after = after;
      return false;
    }
    if (!(served[key] > 0)) return false;
    hints[key] = { loadedAt: null, after: after };
    return true;
  }

  function forget(id) {
    var key = String(id);
    if (!hints[key]) return false;
    delete hints[key];
    return true;
  }

  /**
   * A load of the thread settled. Returns whether the hint went. A load that
   * started before the open is ignored. A failure drops only an unconfirmed hint.
   */
  function settleLoad(id, ok, loadId) {
    var key = String(id);
    var hint = hints[key];
    if (!hint) return false;
    if (hint.after !== null && loadId !== undefined && loadId !== null && loadId <= hint.after) return false;
    if (ok) {
      hint.loadedAt = ++seq;
      return false;
    }
    if (hint.loadedAt !== null) return false;
    delete hints[key];
    return true;
  }

  /** The seq a banner fetch goes out at. */
  function mark() {
    return seq;
  }

  /** A banner fetched after a load came back is authoritative for that read, whatever it serves. */
  function settleBanner(at) {
    var dropped = false;
    Object.keys(hints).forEach(function (key) {
      var loadedAt = hints[key].loadedAt;
      if (loadedAt !== null && loadedAt <= at) {
        delete hints[key];
        dropped = true;
      }
    });
    return dropped;
  }

  function has(id) {
    return String(id) in hints;
  }

  /** The requests whose read a load confirmed and no banner has shown yet. */
  function confirmedIds() {
    return Object.keys(hints).filter(function (key) { return hints[key].loadedAt !== null; });
  }

  function isEmpty() {
    return Object.keys(hints).length === 0;
  }

  window.PmRequestsLocalRead = {
    servedThreads: servedThreads,
    note: note,
    forget: forget,
    settleLoad: settleLoad,
    mark: mark,
    settleBanner: settleBanner,
    has: has,
    confirmedIds: confirmedIds,
    isEmpty: isEmpty,
  };
})();
